export default {
  types: {},
  processors: {},
  customFields: {},
  addressFound: {},
  paymentMethods: {},
  billingSettings: {},
  webhookSettings: {},
  cardMethod: {},
  transferMethod: {},
  webhookSettingsConfigs: {},
  nfeSettings: {},
  nfeSettingsConfigs: {},
  customFieldsValues: {},
  gatewayFieldsValues: {},
  billetMethod: {},
  filterPaymentMethods: {},
  paymentMethodConfigs: {},
  billingSettingsConfigs: {},
  reprocessBilletMethod: {},
  reprocessCardMethod: {},
  balanceMethod: '',
  yapayToken: ''
}



// WEBPACK FOOTER //
// ./src/app/pages/settings/vuex/state.js